module.exports = __webpack_public_path__ + "img/check.5464bf5b.png";